import { render, staticRenderFns } from "./NestedObjectDisplay.vue?vue&type=template&id=66bb4bb3&"
import script from "./NestedObjectDisplay.vue?vue&type=script&lang=js&"
export * from "./NestedObjectDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports